import StatusBadge from "@/components/StatusBadge";
import { booleanOptionIconLabels } from "@/constant/GeneralOptions/boolean";

export const columns = () => {
  const booleanOptionLabelsMap = booleanOptionIconLabels();

  return [
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => <StatusBadge status={row.getValue("status")} />,
    },
    {
      accessorKey: "name",
      header: "Name",
    },
    {
      accessorKey: "sport",
      header: "Sport",
      cell: ({ row }) => <div>{row.original.sport?.name || "SP-All"}</div>,
    },
    {
      accessorKey: "type",
      header: "Type",
      cell: ({ row }) => <div className="capitalize">{row.original.type}</div>,
    },
    {
      accessorKey: "page",
      header: "Page",
      cell: ({ row }) => (
        <div className="capitalize">
          {row.original.page
            .replaceAll("-", " ")
            .toLocaleString("en-US", { caseFirst: "upper" })}
        </div>
      ),
    },
    {
      id: "is_closable",
      accessorFn: (row) => booleanOptionLabelsMap[row.is_closable],
      header: "Is Closable",
      cell: ({ getValue }) => <div className={"flex justify-center"}>{getValue()}</div>,
    },
  ];
};